// @ts-check
// Filtros próprios de um widget (contrato 07, seção 8.3): período, unidade, consultor e período letivo que valem
// para aquele widget no lugar dos filtros do painel. O que não vier fica com o filtro do painel.

/** Períodos aceitos no widget: os atalhos do painel e "todo o período" (sem data). */
export const WIDGET_FILTER_PERIODS = Object.freeze(['TODAY', 'THIS_WEEK', 'THIS_MONTH', 'LAST_30_DAYS', 'THIS_YEAR', 'ALL_TIME']);
export const WIDGET_FILTER_RECORD_KEYS = Object.freeze(['campusId', 'ownerWorkspaceMemberId', 'academicPeriodId']);
export const WIDGET_FILTER_KEYS = Object.freeze(['period', ...WIDGET_FILTER_RECORD_KEYS]);

/** Tipos sem dados: não têm filtros. */
export const WIDGET_TYPES_WITHOUT_FILTERS = Object.freeze(['TEXT', 'IFRAME']);

/**
 * Confere `configuration.widgetFilters`; devolve a mensagem do problema ou null.
 * @param {unknown} value
 * @returns {string | null}
 */
export function findWidgetFiltersProblem(value) {
  if (value === undefined || value === null) return null;
  if (typeof value !== 'object' || Array.isArray(value)) return 'must be an object';
  const source = /** @type {Record<string, unknown>} */ (value);
  const unknownKey = Object.keys(source).find((key) => !WIDGET_FILTER_KEYS.includes(key));
  if (unknownKey) return `.${unknownKey} is not supported (use ${WIDGET_FILTER_KEYS.join(', ')})`;
  if (source.period !== undefined && source.period !== null && !WIDGET_FILTER_PERIODS.includes(/** @type {string} */ (source.period))) {
    return `.period must be one of ${WIDGET_FILTER_PERIODS.join(', ')}`;
  }
  for (const key of WIDGET_FILTER_RECORD_KEYS) {
    const id = source[key];
    if (id !== undefined && id !== null && (typeof id !== 'string' || id === '' || id.length > 100)) return `.${key} must be a record id`;
  }
  return null;
}

/**
 * Há algum filtro próprio preenchido?
 * @param {unknown} value
 */
export function hasWidgetFilters(value) {
  if (!value || typeof value !== 'object') return false;
  const source = /** @type {Record<string, unknown>} */ (value);
  return WIDGET_FILTER_KEYS.some((key) => source[key] !== undefined && source[key] !== null && source[key] !== '');
}
